import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { Toggle } from "@/components/ui/toggle";

const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <div className="w-8 h-8 rounded-md bg-secondary/50 animate-pulse" />
    );
  }

  return (
    <Toggle
      pressed={theme === "dark"}
      onPressedChange={(pressed) => setTheme(pressed ? "dark" : "light")}
      size="sm"
      className="w-8 h-8 p-0"
      aria-label="Toggle theme"
    >
      <Sun 
        className={`h-4 w-4 transition-all duration-300 ${
          theme === "dark" 
            ? "rotate-90 scale-0 opacity-0 absolute" 
            : "rotate-0 scale-100 opacity-100"
        }`}
      />
      <Moon 
        className={`h-4 w-4 transition-all duration-300 ${
          theme === "dark" 
            ? "rotate-0 scale-100 opacity-100" 
            : "-rotate-90 scale-0 opacity-0 absolute"
        }`}
      />
    </Toggle>
  );
};

export default ThemeToggle;